import { doorClient, ImResponse } from '.';

export interface TikTokGrayStatusShop {
  storeId: string;
  externalStoreId: string;
  externalType: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  storeName: string;
  alias: string;
  online: boolean;
  lastActiveTime: string;
}

export type TikTokGrayFuncType = 'REVIEW' | 'VIDEO';

// TikTok 评价灰口客户端店铺在线状态
export const getTikTokGrayStatusShops = (
  externalType: General.PlatformUpperCase,
  funcType?: TikTokGrayFuncType,
) => {
  return doorClient
    .get<ImResponse<{ shopStatus: TikTokGrayStatusShop[] }>>(
      '/oversea-gray/v1/ttsGrayGetShopStatus',
      {
        params: {
          externalType,
          funcType,
        },
      },
    )
    .then((response) => {
      const data = response?.data?.data;
      return data?.shopStatus?.sort?.((item) => (item.online ? -1 : 1));
    });
};
